<script setup lang="ts">
import type {
  EsProductFragment,
  ProductFragment,
  ConfigurableProductFragment,
} from '#graphql-operations'

export interface Props {
  product: EsProductFragment
}

const { pending } = useCart()
const { addToCart } = useAddToCart()
const hasError = ref(false)

const props = defineProps<Props>()

const add = () => {
  const item = [{
    data: {
      sku: props.product.sku,
      quantity: 1,
    },
  }]
  if (!item.length) {
    hasError.value = true
  }
  else {
    const product = props.product as ConfigurableProductFragment & { upsell_products?: Array<{ product: ProductFragment }> }
    const context = {
      suppress: false,
      product: product,
      configurableOptions: product.configurable_options || [],
      upsell: product.upsell_products?.map(item => item.product) || [],
    }
    addToCart(item, context)
    hasError.value = false
  }
}
</script>

<template>
  <div class="add-to-cart">
    <button
      v-if="product?.type === 'simple'"
      type="button"
      :disabled="pending"
      class="add-to-cart__cta"
      :class="{ 'add-to-cart__cta--loading': pending }"
      data-testid="add-to-cart"
      @click.prevent="add"
    >
      <NuxtIcon
        v-if="!pending"
        name="icon:shoppingcart"
        class="icon icon--shoppingcart"
      />

      <NuxtIcon
        v-if="pending"
        name="icon:loader"
        class="icon icon--loading icon--loader"
      />
    </button>
    <button
      v-else
      type="button"
      class="add-to-cart__cta"
      @click.prevent="$emit('open')"
    >
      <NuxtIcon
        name="icon:arrow"
        class="icon icon--arrow"
      />
    </button>
  </div>
</template>

<style>

</style>
